import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import CurrencyExchangeMaintenanceCont from "presentation/view/container/CurrencyExchange/CurrencyExchangeContMain";

CommonEntrypoint(<CurrencyExchangeMaintenanceCont/>)